import React from 'react';

import { defineMessages, useIntl } from 'react-intl-next';

import { Images } from '@atlassian/smart-knowledge-cards/images';

import { useAIAnswerContext } from '../../../ai-answer-dialog/ai-answer-context';
import { useImages } from '../api/useImages/useImages';

const messages = defineMessages({
	heading: {
		id: 'search_ai.visual_knowledge_card.heading',
		defaultMessage: 'Related images',
	},

	// TODO: Replace messages below with final UI
	// https://hello.jira.atlassian.cloud/browse/CCSEARCH-6579
	loading: {
		id: 'search_ai.visual_knowledge_card.loading',
		defaultMessage: 'Loading images...',
	},
	error: {
		id: 'search_ai.visual_knowledge_card.error',
		defaultMessage: 'Error fetching images',
	},
	empty: {
		id: 'search_ai.visual_knowledge_card.empty',
		defaultMessage: 'No images found',
	},
});

export const VisualKnowledgeCard = (): React.JSX.Element | null => {
	const { formatMessage } = useIntl();
	const { commonAttributes, sourceProduct } = useAIAnswerContext();
	const { cloudId, workspaceId, query } = commonAttributes;

	const { images, loading, error } = useImages({
		searchQuery: query,
		cloudId,
		workspaceId,
		product: sourceProduct ?? '',
	});

	// TODO: Replace loading placeholder with final loading state UI
	// https://hello.jira.atlassian.cloud/browse/CCSEARCH-6579
	if (loading) {
		return <>{formatMessage(messages.loading)}</>;
	}

	// TODO: Replace error placeholder with final error state UI
	// https://hello.jira.atlassian.cloud/browse/CCSEARCH-6579
	if (error) {
		return <>{formatMessage(messages.error)}</>;
	}

	// TODO: Replace empty state placeholder with final empty state UI
	// https://hello.jira.atlassian.cloud/browse/CCSEARCH-6579
	if (!images || images.length === 0) {
		return <>{formatMessage(messages.empty)}</>;
	}

	const mappedImages = images.map((image) => ({
		altText: image.altText,
		imageUrl: image.thumbnailUrl,
		sourceTitle: image.title,
		sourceUrl: image.url,
	}));

	return (
		<Images heading={formatMessage(messages.heading)} images={mappedImages} />
	);
};
